<template>
    <sa-page-layout :btnAnnullaVisible="true" :btnSaveVisible="true" :linkback="linkback" :data="jsonData" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <configurazione-contabilita-soggetti-edit-component ref="cmpConfigurazioneContabilitaSoggettiEdit" @update="onUpdateJsonData"></configurazione-contabilita-soggetti-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaSoggettiEditComponent from "../components/ConfigurazioneContabilitaSoggettiEditComponent.vue";

export default {
    components: { SaPageLayout, ConfigurazioneContabilitaSoggettiEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/flussidatifatturazione",
            linkback: "/configurazionecontabilita/soggetti",
            jsonData: {},
            id: "-1",
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {
            // let me = this;
            // me.id = me.$route.params.id;
            // if (me.id === "-1") {
            //     me.$router.replace(me.linkback).catch((err) => {
            //         console.log(err);
            //     });
            // }
        },
    },
};
</script>

<style></style>
